import resources from './ResourcesReducer';

export default resources;
